import React from 'react'

const TransactionsPage = () => {
  return (
    <div>TransactionsPage</div>
  )
}

export default TransactionsPage;